import { Field, reduxForm,change} from 'redux-form';
import { getAppConfigList, updateAppConfig } from './actions';
import React, { Component } from 'react';
import { isInteger, renderCheckBox, renderDateField, renderTextField } from '../../components/reduxFields';
import { SubmitButton, SubmitButtonDisabled } from '../../components/buttons';
import { connect } from 'react-redux';
import GlobalVariables from '../../actions/utilAction';
import moment from 'moment';


const validate = (values) => {
  const errors = {};
  // console.log(values);
  if (values.ConfigData && values.ConfigData.length) {

    const configDataErrors = [];
    values.ConfigData.forEach((configDataObj, configDataIndex) => {
      const configDataObjErrors = {};
      // console.log('configDataObj-->', configDataObj);
      if (configDataObj.Key === 'PAGE_SIZE' && (!configDataObj.Value || configDataObj.Value === '')) {
        configDataObjErrors.Value = 'Please enter page number';
        configDataErrors[configDataIndex] = configDataObjErrors;
      } else if (configDataObj.Key === 'PAGE_SIZE' && configDataObj.Value && parseInt(configDataObj.Value, 10) === 0) {
        configDataObjErrors.Value = 'Page size cannot be zero';
        configDataErrors[configDataIndex] = configDataObjErrors;
      } else if (configDataObj.Key === 'PAGE_SIZE' && configDataObj.Value && configDataObj.Value < 5) {
        configDataObjErrors.Value = 'Enter page size greater than or equal to 5';
        configDataErrors[configDataIndex] = configDataObjErrors;
      } else if (configDataObj.Key === 'PAGE_SIZE' && configDataObj.Value && configDataObj.Value >= 5) {
        GlobalVariables.PageSize = configDataObj.Value;
      }
      return configDataObjErrors;
    });

    if (configDataErrors.length) {

      errors.ConfigData = configDataErrors;
    }
  }
  return errors;
};

class AppConfig extends Component {
  constructor(props) {   
    super(props);
     this.state = ({
      FinancialsClosingDate: null,
      parentCheck:false      
    });
  }

  loadData() {
    this.props.getAppConfigList();
  }
  componentWillMount() {
    this.loadData();
  }

  handleOncheck = (e, name) => {
    if (e.target.checked) {
      this.setState({ parentCheck: true });
      if (e.target.checked) {
        // Check the SHOW_CLOCKIN_CLOCKOUT_ON_SESSION_NOTE checkbox
        this.props.dispatch(change('AppConfigForm', 'ConfigData[8].Value', true));
      }
      return;
    }
    this.setState({ parentCheck: false });
    if (!e.target.checked) {
      // Uncheck the SHOW_CLOCKIN_CLOCKOUT_ON_SESSION_NOTE checkbox
      this.props.dispatch(change('AppConfigForm', 'ConfigData[8].Value', false));
    }
  };

  renderSOAPData() {
    return this.props.appConfigList.data.map((Obj, i) => {
      let view = '';
      if (Obj.configType === 1) {
        view =
        <li key={Obj.id}  style={Obj.key === "REQUIRED_CLOCKIN_CLOCKOUT_ON_SESSION_NOTE" ? { paddingLeft: '2rem' } : {}} >{Obj.label}
          <span>
            <Field
              name={`ConfigData[${i}].Value`}
              // name={Obj.attributes.Value === 'True' ? true : false}
              type="text"
              // onChange={this.handleValueChange.bind(this, Obj)}
              value ={Obj.key === "SHOW_CLOCKIN_CLOCKOUT_ON_SESSION_NOTE"&&this.state.parentCheck}
              onChange = {Obj.key === "REQUIRED_CLOCKIN_CLOCKOUT_ON_SESSION_NOTE"?(e)=>{this.handleOncheck(e,`ConfigData[${i}].Value`)}:null}
              checked = {Obj.key === "SHOW_CLOCKIN_CLOCKOUT_ON_SESSION_NOTE"&&this.state.parentCheck}
              component={renderCheckBox} onCheck ={this.state.parentCheck} />
             
          </span>
        </li>;
      }
      return view;
    });
  };
  renderPaginationData() {

    return this.props.appConfigList.data.map((Obj, i) => {
      let view = '';
      if (Obj.configType === 2) {
        view = <li key={i}>{Obj.label}
            <span>
              <Field
                name={`ConfigData[${i}].Value`}
                // name={Obj.attributes.Value === 'True' ? true : false}
                type="text"
                normalize ={isInteger}
                maxLength = {6}
                // onChange={this.handleValueChange.bind(this, Obj)}
                component={renderTextField}/>
            </span>
          </li>;
      }
      return view;
    });
  };

  renderRestrictSignaturesData() {
    return this.props.appConfigList.data.map((Obj, i) => {
      let view = '';
      if (Obj.configType === 4) {
        view =
        <li key={Obj.id}>{Obj.label}
          <span>
            <Field
              name={`ConfigData[${i}].Value`}
              // name={Obj.attributes.Value === 'True' ? true : false}
              type="text"
              // onChange={this.handleValueChange.bind(this, Obj)}
              component={renderCheckBox}/>
          </span>
        </li>;
      }
      return view;
    });
  };

  renderAIGenerativeSetting() {
    return this.props.appConfigList.data.map((Obj, i) => {
      let view = '';
      if (Obj.configType === 5) {
        view = <li key={Obj.id}>{Obj.label}
            <span>
              <Field
                name={`ConfigData[${i}].Value`}
                 type='text'               
                //  openToYearSelection={true}
                 component={renderCheckBox} />
            </span>
          </li>;
      }
      return view;
    })
  }

  onDateChange = (input, value, data, action) => {
    input.onChange(moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss'));     
    this.setState({ FinancialsClosingDate: value });
}


  renderFinancialsClosingDate() {

    return this.props.appConfigList.data.map((Obj, i) => {
      let view = '';
      if (Obj.configType === 3) {
        view = <li key={i}>{Obj.label}
            <span>
              <Field
                name={`ConfigData[${i}].Value`}
                 //placeholder="Session Date"
                 locale="en-US"                 
                 selected={this.state.FinancialsClosingDate ? this.state.FinancialsClosingDate : this.props.financialsClosingDate}
                 onDateChange={this.onDateChange}                 
                 openToYearSelection={true}
                 //maxDate={new Date()}
                 component={renderDateField} />
            </span>
          </li>;
      }
      return view;
    });
  };

  onSubmit = (formData) => {
    if (formData && formData.ConfigData) {
      let pageSize = GlobalVariables.PageSize;
      formData.ConfigData.map((Obj) => {
        switch (Obj.Key) {
          case 'PAGE_SIZE':
            return (pageSize = Obj.Value);
          default:
            return Obj;
        }
      });
      GlobalVariables.PageSize = pageSize;
    }
    // console.log(formData)
    this.props.updateAppConfig(formData.ConfigData);
  };

  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        <h2 className="page_title">Configuration</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
            {this.props.loginUserInfo.users3.userRoles.roleName.toUpperCase() === 'ADMIN' || this.props.loginUserInfo.users3.userRoles.roleName.toUpperCase() === 'AGENCY ADMIN' || this.props.modifySignatureRequirementsOnSessionNotesPermission ?
              <div className="row">
                <div className="col-sm-5 setting_card mb-30">
                  {/* <div className='mt10 custm_appointmenttype'><span>*Please note: To see and apply any setting changes in the mobile app, users will need to log out and then log back in.</span></div> */}
                  <h3>Session Note Settings</h3>
                  <div className='mt10 custm_appointmenttype'><span style={{color: "#09a7dc"}}>*These settings can be overridden by the signature settings at payer level.</span></div>
                  <div className="familydl">
                    {(this.props.appConfigList && this.props.appConfigList.data && this.props.appConfigList.data.length) ?
                      <ul>
                        {this.renderSOAPData()}
                      </ul>
                      : <div className="familydl text-center no-record">No record found.</div>}
                  </div>
                </div>
              </div>
              : null}
              {(this.props.loginUserInfo.users3.userRoles.roleName.toUpperCase() === 'ADMIN' || this.props.loginUserInfo.users3.userRoles.roleName.toUpperCase() === 'AGENCY ADMIN' || this.props.modifySignatureRequirementsOnSessionNotesPermission) ?
              <div className="row">
                <div className="col-sm-5 setting_card mb-30">
                  <h3>Restrict Signatures</h3>
                  <div className="familydl">
                    {(this.props.appConfigList && this.props.appConfigList.data && this.props.appConfigList.data.length) ?
                      <ul>
                        {this.renderRestrictSignaturesData()}
                      </ul>
                      : <div className="familydl text-center no-record">No record found.</div>}
                  </div>
                </div>
              </div>:null}
              {this.props.loginUserInfo.users3.userRoles.roleName.toUpperCase() === 'ADMIN' || this.props.loginUserInfo.users3.userRoles.roleName.toUpperCase() === 'AGENCY ADMIN' ?
              <div className="row">
                <div className="col-sm-5 setting_card mb-30">
                  <h3>Page Settings</h3>
                  <div className="familydl">
                    {(this.props.appConfigList && this.props.appConfigList.data && this.props.appConfigList.data.length) ?
                      <ul>
                        {this.renderPaginationData()}
                      </ul>
                      : <div className="familydl text-center no-record">No record found.</div>}
                  </div>
                </div>
              </div>
              : null}          
              {this.props.lockScheduleUptoSpecifiedDate ?     
              <div className="row">
                <div className="col-sm-5 setting_card mb-30">
                  <h3>Lock Scheduler</h3>
                  <div className="familydl">
                    {(this.props.appConfigList && this.props.appConfigList.data && this.props.appConfigList.data.length) ?
                      <ul>
                        {this.renderFinancialsClosingDate()}
                      </ul>
                      : <div className="familydl text-center no-record">No record found.</div>}
                       <div className='mt20'><small className="redfont font12">Changing the lock date here will override any scheduling locks set for an individual user. Please note that once the schedule is locked, no appointments can be created or modified on or before the lock date.</small></div>
                  </div>
                </div>
              </div>:null}
              {this.props.appConfigAIGenerateSetting && this.props.appConfigAIGenerateSetting.isEnableGenerativeAIFeatures ? 
                <div className="row">
                <div className="col-sm-5 setting_card mb-30">
                  <h3>Generate AI Settings</h3>
                  <div className="familydl">
                    {(this.props.appConfigList && this.props.appConfigList.data && this.props.appConfigList.data.length) &&
                        <ul>
                          {this.renderAIGenerativeSetting()}
                        </ul>
                    }
                  </div>
                </div>
              </div>: null}
              
              <div className="row">
                <div className="col-sm-12 pt20 btn_rt">
                  {this.props.loading ?
                    <SubmitButtonDisabled label="Saving"/> :
                    <SubmitButton label="Save"/>}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

AppConfig = reduxForm({
  form: 'AppConfigForm',
  validate,
  enableReinitialize: true, // this is needed!!
})(AppConfig);

function mapStateToProps(state) {

   // Start For Role Permission
   let dashboardScreenPermission = [];
   let userActionPermission = [];  
   if (state.login.userPermission) {
    let dashboardModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'DASHBOARD');
    dashboardScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === dashboardModulePermission[0].moduleId);
     let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'SCHEDULING');
     let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'SCHEDULING_LIST' && obj.moduleId === userModulePermission[0].moduleId);
     userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
   }
 
   let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission
 
   //let lockScheduleUptoSpecifiedDate = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LOCK_SCHEDULE_UPTO_SPECIFIED_DATE')[0].permission : false;
   let lockScheduleUptoSpecifiedDate = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LOCK_SCHEDULE_UPTO_SPECIFIED_DATE')[0] ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LOCK_SCHEDULE_UPTO_SPECIFIED_DATE')[0].permission : false;

   let modifySignatureRequirementsOnSessionNotesPermission = hasDefaultAccess ? true : dashboardScreenPermission && dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_MODIFY_SIGNATURE_REQUIREMENTS_ON_SESSION_NOTES_UNDER_SETTINGS')[0] ? dashboardScreenPermission.filter((obj) => obj.screenKey === 'DASHBOARD_MODIFY_SIGNATURE_REQUIREMENTS_ON_SESSION_NOTES_UNDER_SETTINGS')[0].permission : false;

   // End For Role Permission


  let initialValueData = {};
  let newData = [];
  let financialsClosingDate = '';
  let appConfigAIGenerateSetting = []

  if (state.appConfig.appConfigList && state.appConfig.appConfigList.data && state.appConfig.appConfigList.data.length) {
    state.appConfig.appConfigList.data.filter((data) => {

      if(data.key === 'LOCK_SCHEDULER')
      {
        financialsClosingDate =  data.value ? data.value : ''
      }

      let x = {
        'id': data.id,
        'Key': data.key,
        'Value': (data.value || '').toLowerCase() === 'true' ? true : (data.value || '').toLowerCase() === 'false' ? false : data.value,
        'ConfigType': data.configType,
      };
      return newData.push(x);
    });
    initialValueData['ConfigData'] = newData;
  }

  if (state.appConfig.appConfigList && state.appConfig.appConfigList.data && state.appConfig.appConfigList.data.length) {
    appConfigAIGenerateSetting = state.appConfig.appConfigList.data.find(data => data.key === 'GEN_AI_NARRATIVE_SUMMARY');
  }

  return {
    appConfigList: state.appConfig.appConfigList,
    initialValues: initialValueData,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    financialsClosingDate : financialsClosingDate,
    loginUserInfo: state.login.loginUserInfo,
    lockScheduleUptoSpecifiedDate: lockScheduleUptoSpecifiedDate,
    modifySignatureRequirementsOnSessionNotesPermission: modifySignatureRequirementsOnSessionNotesPermission,
    appConfigAIGenerateSetting
  };
}


export default connect(mapStateToProps, { getAppConfigList, updateAppConfig })(AppConfig);



// WEBPACK FOOTER //
// ./src/modules/AppConfig/index.js